import { Controller } from "@hotwired/stimulus"
import * as CookieConsent from "vanilla-cookieconsent"

// Lien « Gérer les cookies » : rouvre la modale de préférences à la demande, seul
// moyen de revenir sur son choix une fois la bannière décidée (art. 7.3 RGPD, #1933).
//
// Contrôleur distinct de `cookie-consent` parce que le lien vit dans le pied de page
// ou dans le profil, hors du scope DOM de la bannière — une action Stimulus ne
// traverse pas les scopes. showPreferences() agit sur le singleton de la librairie,
// initialisé par CookieConsentBannerComponent — voir CookiePreferencesLinkComponent
// pour la condition qui garantit la présence de la bannière là où le lien s'affiche.
export default class extends Controller {
  show(event) {
    event.preventDefault()
    CookieConsent.showPreferences()
  }
}
